import {
  ContentLayout,
  PageNotFound,
  Loader,
  HeaderBreadcrumbs,
  useDropdownApis,
  NewFormCardWrapper,
} from "../../../shared";
import * as React from "react";
import {
  Button,
  Stack,
  Card,
  Switch,
  Typography,
  Grid,
  Avatar,
  Box,
  TextField,
  Divider,
  Radio,
  Tooltip,
  InputAdornment,
  createFilterOptions,
  FormHelperText,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Popper,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import SimpleReactValidator from "simple-react-validator";
import Avadar_img from "../../../assets/images/Icons/Avadar_img.png";
import InputControl from "../../../shared/components/InputControl";
import infoIcon from "../../../assets/images/Icons/ic_info.svg";
import { SketchPicker } from "react-color";

import "react-quill/dist/quill.snow.css";
import { useParams } from "react-router-dom";
import { useProducts } from "../hooks";
import { MultiLanguageNameTable } from "../../Category";

export const CreateOrEditProducts = () => {
  const { id } = useParams();
  const updateMode = id ? true : false;
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      validators: {
        IconFormat: {
          message: "The Image  should be png, jpg, jpeg",
          rule: (value) => {
            if (
              ![
                "image/png",
                "image/jpeg",
                "image/jpg",
                "image/svg",
                "image/gif",
              ].includes(value.type)
            ) {
              return false;
            }
          },
        },
        IconSize: {
          message: "The Image Size should be less than 1MB",
          rule: (value) => {
            const maxSize = 1048576; //1mb
            if (value?.size > maxSize) {
              return false;
            }
          },
        },
      },
    }),
  );
  const [anchorElColorPicker, setAnchorElColorPicker] = React.useState(null);
  const [openColorPicker, setOpenColorPicker] = React.useState(false);
  const colorPickerRef = React.useRef(null);
  const colorPickerContainerRef = React.useRef(null);
  const colorPickerPopperId = openColorPicker
    ? "color-picker-popper"
    : undefined;

  // Effect for handle outside click of color picker
  React.useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        colorPickerRef.current &&
        colorPickerContainerRef.current &&
        !colorPickerContainerRef.current.contains(event.target) &&
        !colorPickerRef.current.contains(event.target)
      ) {
        setOpenColorPicker(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [colorPickerRef, colorPickerContainerRef]);

  React.useEffect(() => {
    setOpenColorPicker(Boolean(anchorElColorPicker));
  }, [anchorElColorPicker]);

  // Handler for open color palate
  const handleColorPickerOpen = (event) => {
    setAnchorElColorPicker(anchorElColorPicker ? null : event.currentTarget);
  };
  const {
    regionState,
    state,
    isCreate,
    isEditMode,
    globalData,
    categoriesList,
    taxGroupList,
    accountsList,
    onUpdateProduct,
    onSaveProduct,
    handleProductInputChange,
    handleVarientNestedInput,
    handleColor,
    handleLoyaltyCheckboxChanges,
    isLoyaltyOptionInclude,
  } = useProducts({ IsAdd: true, isDetailsId: id ? id : false, isMultiLanguage: true });
  const { reportSettingsList } = useDropdownApis({
    isReportSettingsList: true,
  });

  const { classes } = reportSettingsList;

  const { isSaveButton, updateData, isLoading, imageData } =
    state.updateDetails;
  const {
    name,
    short_description,
    modifier,
    product_type,
    plu,
    category_id,
    image,
    tax_group_id,
    tags,
    marketing_tags,
    variants,
    has_variant,
    sticker_printing,
    old_plu,
    bump_screen_tags,
    colour,
    alias,
    kilojoules,
    redcat_category,
    redcat_plu_class,
  } = updateData;
  const onSubmit = () => {
    if (validator.current.allValid()) {
      updateMode ? onUpdateProduct(id) : onSaveProduct();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const filter = createFilterOptions();

  const categoryOptions = categoriesList?.map((v) => {
    return { value: v.id, label: v.name };
  });

  const classesOptions =
    classes?.map((v) => {
      return { value: v.name, label: v.name };
    }) ?? [];

  const reportCategoryOptions = React.useMemo(() => {
    if (!redcat_plu_class) return [];

    const parentCategory = classes?.find(
      (cat) => cat.name === redcat_plu_class,
    );

    return (
      parentCategory?.categories?.map(({ name }) => ({
        value: name,
        label: name,
      })) ?? []
    );
  }, [redcat_plu_class]);

  if (state.httpStatusCodes.details === 404) {
    return <PageNotFound />;
  }

  return (
    <>
      {validator.current.purgeFields()}
      {id && isLoading ? (
        <Loader />
      ) : (
        <ContentLayout
          title={id ? state.basicDetails.details?.name : "New Product"}
          rightContent={
            <>
              <Button
                type="button"
                size="medium"
                variant="contained"
                disabled={isSaveButton}
                onClick={onSubmit}
              >
                {id ? "Update" : "Save"}
              </Button>
            </>
          }
          breadcrumbs={
            <HeaderBreadcrumbs
              heading=""
              links={[
                { name: "Dashboard", href: "/" },
                { name: "Products", href: "/products" },
                id
                  ? {
                      name: state.basicDetails.details?.name,
                      href: `/products/details/${id}`,
                    }
                  : null,
                { name: id ? "Edit" : "Create" },
              ].filter(Boolean)}
            />
          }
        >
          <NewFormCardWrapper
            title="details"
            gap="20px"
            bodyGap="20px"
            sx={{ mb: "24px" }}
          >
            <Box>
              <Stack direction="row" gap="20px">
                <Avatar
                  sx={{ height: "80px", width: "80px" }}
                  variant="rounded"
                >
                  <img
                    width="80px"
                    height="80px"
                    src={image ? image : Avadar_img}
                    alt="icon"
                  />
                </Avatar>

                <Stack gap="8px">
                  <div>
                    <input
                      id="contained-button-file"
                      name="image"
                      type="file"
                      onChange={(e) => handleProductInputChange(e)}
                      style={{ display: "none" }}
                    />
                    <label htmlFor="contained-button-file">
                      <Button
                        color="info"
                        component="span"
                        sx={{ mt: 2 }}
                        onClick={(e) => handleProductInputChange(e)}
                        variant="outlined"
                        size="small"
                      >
                        {id ? "Change" : "Upload"}
                      </Button>
                    </label>
                  </div>
                  <Typography variant="caption" color="#808080">
                    Upload an image with 1:1 ratio and less than 1MB.
                  </Typography>
                  <FormHelperText sx={{ color: "#C60808" }}>
                    {validator.current.message(
                      "Image",
                      imageData,
                      "IconSize|IconFormat",
                    )}
                  </FormHelperText>
                </Stack>
              </Stack>
            </Box>
            <Divider />
            <Stack gap="12px">
              <Stack gap="16px">
                <Stack gap="4px">
                  <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                    Product Naming
                  </Typography>
                  <Typography
                    variant="caption"
                    color="gray.50"
                    sx={{ fontSize: "12px" }}
                  >
                    Product Name is the full name used across the
                    system. Product Short Name is used for limited-space screens
                    like Bump Screen/KDS.
                  </Typography>
                </Stack>
              </Stack>
              <MultiLanguageNameTable>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "16%" }}>Language</TableCell>
                    <TableCell sx={{ width: "42%" }}>Product Name*</TableCell>
                    <TableCell sx={{ width: "42%" }}>
                      Product Short Name*
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {state.productNamingsLoading ? (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        <Loader />
                      </TableCell>
                    </TableRow>
                  ) : (
                    state.productNamings.map((cat, index) => {
                      const productNameMessage = validator.current.message(
                        `${cat.code} Product Name`,
                        cat.locale_name,
                        "required",
                      );
                      const productAliasMessage = validator.current.message(
                        `${cat.code} Product Alias`,
                        cat.locale_alias,
                        "required",
                      );
                      return (
                        <TableRow key={index}>
                          <TableCell
                            sx={{ fontSize: "16px", whiteSpace: "nowrap" }}
                          >
                            {cat.lang}
                          </TableCell>
                          <TableCell>
                            <InputControl
                              name={`locale_name`}
                              label=""
                              autoComplete="off"
                              onChange={(e) =>
                                handleProductInputChange(e, index)
                              }
                              value={cat.locale_name || ""}
                              error={!!productNameMessage}
                              helperText={productNameMessage}
                            />
                          </TableCell>
                          <TableCell>
                            <InputControl
                              name={`locale_alias`}
                              label=""
                              autoComplete="off"
                              onChange={(e) =>
                                handleProductInputChange(e, index)
                              }
                              value={cat.locale_alias || ""}
                              error={!!productAliasMessage}
                              helperText={productAliasMessage}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </MultiLanguageNameTable>
            </Stack>

            <InputControl
              name="short_description"
              label="Short Description*"
              value={short_description}
              onChange={handleProductInputChange}
              error={validator.current.message(
                "Description",
                short_description,
                "required|min:2",
              )}
              helperText={validator.current.message(
                "Description",
                short_description,
                "required|min:2",
              )}
            />
            <Stack direction="row" gap="20px">
              <InputControl
                type="select"
                name="category_id"
                value={category_id}
                label="Category*"
                optionValue={categoryOptions}
                onChange={handleProductInputChange}
                error={validator.current.message(
                  "Category",
                  category_id,
                  "required",
                )}
                helperText={validator.current.message(
                  "Category",
                  category_id,
                  "required",
                )}
                required
              />

              <InputControl
                type="select"
                name="product_type"
                label="Product Type*"
                value={product_type}
                disabled={updateMode}
                onChange={handleProductInputChange}
                optionValue={globalData?.product?.type ?? []}
                error={validator.current.message(
                  "Product Type",
                  product_type,
                  "required",
                )}
                helperText={validator.current.message(
                  "Product Type",
                  product_type,
                  "required",
                )}
              />
            </Stack>
          </NewFormCardWrapper>

          {/* Display settings */}
          <NewFormCardWrapper title="Display settings" sx={{ mb: "24px" }}>
            <Stack direction="row" gap="20px">
              {/* Color picker container */}
              <Box width="100%" ref={colorPickerContainerRef}>
                <TextField
                  fullWidth
                  label="Colour Code"
                  required
                  value={colour ? colour.toUpperCase() : ""}
                  aria-describedby={colorPickerPopperId}
                  onClick={handleColorPickerOpen}
                  sx={{ "& .MuiInputBase-root": { cursor: "pointer" } }}
                  inputProps={{
                    readOnly: true,
                    style: { cursor: "pointer" },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Box
                          sx={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "3px",
                            border: "1px solid #e6e6e6",
                            bgcolor: !colour ? "#F2F2F2" : colour,
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  error={validator.current.message(
                    "Color Code",
                    colour,
                    "required",
                  )}
                  helperText={validator.current.message(
                    "Color Code",
                    colour,
                    "required",
                  )}
                />
                {/* Popper component */}
                <Popper
                  ref={colorPickerRef}
                  id={colorPickerPopperId}
                  open={openColorPicker}
                  anchorEl={anchorElColorPicker}
                  sx={{ zIndex: 1300 }}
                >
                  <SketchPicker
                    color={colour ?? ""}
                    onChangeComplete={(color) => {
                      handleColor({ value: color.hex });
                    }}
                    disableAlpha
                  />
                </Popper>
              </Box>
            </Stack>
            {product_type !== "modifier" && (
              <InputControl
                value={tags}
                type="dropdown"
                name="tags"
                label="Bump Screen Tags"
                multiple
                className="tags-input"
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    handleProductInputChange({
                      target: {
                        name: "tags",
                        value: newValue,
                      },
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    handleProductInputChange({
                      target: {
                        name: "tags",
                        value: newValue.inputValue,
                      },
                    });
                  } else {
                    handleProductInputChange({
                      target: {
                        name: "tags",
                        value: newValue,
                      },
                    });
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option,
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push(inputValue);
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={state?.productTags}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option;
                }}
                renderOption={(props, option) => <li {...props}>{option}</li>}
                freeSolo
                renderInput={(params) => (
                  <TextField {...params} label="Product tags" />
                )}
              />
            )}
            <InputControl
              value={marketing_tags}
              type="dropdown"
              name="marketing_tags"
              label="B Tags"
              multiple
              className="tags-input"
              onChange={(event, newValue) => {
                if (typeof newValue === "string") {
                  handleProductInputChange({
                    target: {
                      name: "marketing_tags",
                      value: newValue,
                    },
                  });
                } else if (newValue && newValue.inputValue) {
                  // Create a new value from the user input
                  handleProductInputChange({
                    target: {
                      name: "marketing_tags",
                      value: newValue.inputValue,
                    },
                  });
                } else {
                  handleProductInputChange({
                    target: {
                      name: "marketing_tags",
                      value: newValue,
                    },
                  });
                }
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                const { inputValue } = params;
                // Suggest the creation of a new value
                const isExisting = options.some(
                  (option) => inputValue === option,
                );
                if (inputValue !== "" && !isExisting) {
                  filtered.push(inputValue);
                }

                return filtered;
              }}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              id="free-solo-with-text-demo"
              options={state?.marketingTags}
              getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === "string") {
                  return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue) {
                  return option.inputValue;
                }
                // Regular option
                return option;
              }}
              renderOption={(props, option) => <li {...props}>{option}</li>}
              freeSolo
              renderInput={(params) => (
                <TextField {...params} label="Marketing Tags" />
              )}
            />

            {!["bundle", "modifier"].includes(product_type) && (
              <InputControl
                value={bump_screen_tags}
                type="dropdown"
                name="bump_screen_tags"
                label="Bump Screen Tags"
                className="tags-input"
                multiple
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    handleProductInputChange({
                      target: {
                        name: "bump_screen_tags",
                        value: newValue,
                      },
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    handleProductInputChange({
                      target: {
                        name: "bump_screen_tags",
                        value: newValue.inputValue,
                      },
                    });
                  } else {
                    handleProductInputChange({
                      target: {
                        name: "bump_screen_tags",
                        value: newValue,
                      },
                    });
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option,
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push(inputValue);
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={state?.BumpScreenTags}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option;
                }}
                renderOption={(props, option) => <li {...props}>{option}</li>}
                freeSolo
                renderInput={(params) => (
                  <TextField {...params} label="Bump Screen Tags" />
                )}
              />
            )}
          </NewFormCardWrapper>

          {/* Nutritional information section */}
          <NewFormCardWrapper
            title="Nutritional information"
            sx={{ mb: "24px" }}
          >
            <InputControl
              name="kilojoules"
              type="number"
              label="Energy-Average Qty per Serve (kJ)"
              value={kilojoules}
              onChange={handleProductInputChange}
              isDisabledKeys={["-", "."]}
            />
          </NewFormCardWrapper>

          {/* System configuration section */}
          <NewFormCardWrapper title="System configuration" sx={{ mb: "24px" }}>
            <InputControl
              type="select"
              name="tax_group_id"
              label="Tax Group*"
              optionValue={taxGroupList}
              value={tax_group_id}
              onChange={handleProductInputChange}
              error={validator.current.message(
                "Tax Group",
                tax_group_id,
                "required",
              )}
              helperText={validator.current.message(
                "Tax Group",
                tax_group_id,
                "required",
              )}
            />

            <Stack direction="row" gap="12px">
              <InputControl
                type="outlinedInput"
                inputType="text"
                inputLabel="PLU Code"
                label="PLU Code"
                placeholder="PLU Code"
                name="plu"
                value={plu}
                onChange={handleProductInputChange}
                endAdornment={
                  <InputAdornment position="start">
                    <Tooltip title="If left empty, will be auto-generated.">
                      <img
                        alt="details"
                        src="/icons/ic_info.svg"
                        style={{ opacity: 0.4 }}
                      />
                    </Tooltip>
                  </InputAdornment>
                }
              />
              <InputControl
                name="old_plu"
                label="Old PLU Code"
                value={old_plu}
                onChange={handleProductInputChange}
              />
            </Stack>

            <InputControl
              type="dropdown"
              options={classesOptions}
              value={
                classesOptions?.find(
                  (classItem) => classItem.value === redcat_plu_class,
                ) ?? null
              }
              disableClearable={true}
              onChange={(e, newValue) => {
                handleProductInputChange({
                  target: {
                    name: "redcat_plu_class",
                    value: newValue?.value ?? newValue,
                  },
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Class Name"
                  required
                  error={validator.current.message(
                    "Report Class Name",
                    redcat_plu_class,
                    "required",
                  )}
                  helperText={validator.current.message(
                    "Report Class Name",
                    redcat_plu_class,
                    "required",
                  )}
                />
              )}
            />

            <InputControl
              type="dropdown"
              options={reportCategoryOptions}
              value={
                reportCategoryOptions?.find(
                  (classItem) => classItem.value === redcat_category,
                ) ?? null
              }
              disableClearable={true}
              onChange={(e, newValue) => {
                handleProductInputChange({
                  target: {
                    name: "redcat_category",
                    value: newValue?.value ?? newValue,
                  },
                });
              }}
              disabled={!redcat_plu_class}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Report Category"
                  required
                  error={validator.current.message(
                    "Report Category",
                    redcat_category,
                    "required",
                  )}
                  helperText={validator.current.message(
                    "Report Category",
                    redcat_category,
                    "required",
                  )}
                />
              )}
            />
          </NewFormCardWrapper>

          {/* Product sticker printing section */}
          {["retail", "platter"].includes(product_type) && (
            <NewFormCardWrapper
              title="Product sticker printing"
              sx={{ mb: "24px" }}
            >
              <Stack direction="row" justifyContent="space-between">
                <Stack direction="row" gap={1} alignItems="center">
                  <Box
                    component="img"
                    src={infoIcon}
                    width="16px"
                    height="16px"
                  />
                  <Typography
                    sx={{
                      color: "#636363",
                      fontSize: "14px",
                      lineHeight: "16.94px",
                      fontWeight: "400",
                    }}
                  >
                    Enabling this will make the product eligible for sticker
                    printing
                  </Typography>
                </Stack>
                <Switch
                  checked={sticker_printing ? true : false}
                  name="sticker_printing"
                  onChange={handleProductInputChange}
                />
              </Stack>
            </NewFormCardWrapper>
          )}

          {/* Loyalty Cards Section */}
          <NewFormCardWrapper
            title="Loyalty Cards"
            gap="8px"
            sx={{ mb: "24px" }}
          >
            <FormGroup row>
              {globalData?.loyalty_cards?.loyalty_card_types.map((details) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isLoyaltyOptionInclude(details)}
                      onChange={(e) => handleLoyaltyCheckboxChanges(e, details)}
                    />
                  }
                  label={details.label}
                />
              ))}
            </FormGroup>
            <Stack direction="row" gap={1}>
              <Box component="img" src={infoIcon} />
              <Typography
                sx={{
                  color: "#636363",
                  fontSize: "14px",
                  lineHeight: "16.94px",
                  fontWeight: "400",
                }}
              >
                If selected, purchasing this product will earn loyalty points
                for the associated card type.
              </Typography>
            </Stack>
          </NewFormCardWrapper>

          {/* Accounts */}
          {product_type !== "bundle" && (
            <>
              {!isEditMode && isCreate && (
                <NewFormCardWrapper title="Accounts" sx={{ mb: "24px" }}>
                  <InputControl
                    value={accountsList.selectedAccountIds}
                    type="dropdown"
                    name="account_id"
                    label="Account Name"
                    className="tags-input"
                    options={state.accountsList.listData}
                    multiple
                    onChange={(_, newValue) => {
                      handleProductInputChange({
                        target: {
                          name: "account_id",
                          value: newValue,
                        },
                      });
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);
                      return filtered;
                    }}
                    selectOnFocus
                    handleHomeEndKeys
                    id="account_name"
                    getOptionLabel={(option) => {
                      return option.name;
                    }}
                    renderOption={(props, option) => (
                      <li {...props}>{option.name}</li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Account Name"
                        required
                        error={validator.current.message(
                          "account_name",
                          state.accountsList.selectedAccountIds,
                          "required",
                        )}
                        helperText={validator.current.message(
                          "account_name",
                          state.accountsList.selectedAccountIds,
                          "required",
                        )}
                        size="medium"
                      />
                    )}
                  />
                </NewFormCardWrapper>
              )}
            </>
          )}

          {product_type !== "modifier" && (
            <>
              {!id && (
                <Card sx={{ p: "32px 24px", mb: "24px" }}>
                  <Stack
                    flexDirection="row"
                    justifyContent="space-between"
                    alignItems="center"
                    pb={has_variant ? "24px" : "0px"}
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ width: "150px", color: "gray.50" }}
                    >
                      Product Variants
                    </Typography>
                    <Switch
                      checked={has_variant ? true : false}
                      name="has_variant"
                      onChange={handleProductInputChange}
                    />
                  </Stack>

                  {has_variant ? (
                    <>
                      <Divider
                        sx={{
                          width: "calc(100% + 48px)",
                          mr: " -24px",
                          ml: " -24px",
                        }}
                      />
                      {variants?.map((data, index) => (
                        <>
                          <Stack
                            direction="row"
                            alignItems="start"
                            gap="12px"
                            py="20px"
                            width="100%"
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              minWidth="105px"
                            >
                              <Radio
                                size="small"
                                checked={data.default === 1}
                                onChange={(e) => {
                                  handleVarientNestedInput("Default", e, index);
                                }}
                                // value={row.id}
                                name="radio-buttons"
                                sx={{
                                  p: "3.5px",
                                }}
                              />
                              <Typography variant="caption" color="#666666">
                                {data.default ? "Default" : "Set as default"}
                              </Typography>
                            </Stack>

                            <Stack
                              display="grid"
                              gridTemplateColumns={{
                                xs: "1fr",
                                sm: "1fr 1fr",
                                md: "repeat(3, 1fr)",
                              }}
                              width="100%"
                              gap="20px"
                            >
                              {data.namings.map((vName, cIndex) => {
                                const label =
                                  regionState.languagesOptions.find(
                                    (lang) => lang.code === vName.code,
                                  )?.name || "";
                                const productNameMessage =
                                  validator.current.message(
                                    `${vName.code} Variant Name`,
                                    vName.locale_name,
                                    "required",
                                  );
                                return (
                                  <InputControl
                                    inputType="text"
                                    label={label + " Name"}
                                    name="locale_name"
                                    fullWidth={false}
                                    value={vName.locale_name}
                                    onChange={(e) => {
                                      handleVarientNestedInput(
                                        "onChange",
                                        e,
                                        index,
                                        cIndex,
                                      );
                                    }}
                                    error={!!productNameMessage}
                                    helperText={productNameMessage}
                                  />
                                );
                              })}
                              <InputControl
                                type="outlinedInput"
                                inputType="text"
                                inputLabel="PLU Code"
                                placeholder="PLU Code"
                                label="PLU Code"
                                name="plu"
                                value={data.plu}
                                onChange={(e) => {
                                  handleVarientNestedInput(
                                    "onChange",
                                    e,
                                    index,
                                  );
                                }}
                                endAdornment={
                                  <InputAdornment position="start">
                                    <Tooltip title="If left empty, will be auto-generated.">
                                      <img
                                        alt="details"
                                        src="/icons/ic_info.svg"
                                        style={{ opacity: 0.4 }}
                                      />
                                    </Tooltip>
                                  </InputAdornment>
                                }
                              />

                              <InputControl
                                type="outlinedInput"
                                inputType="text"
                                placeholder="Old PLU Code"
                                name="old_plu"
                                value={data.old_plu}
                                onChange={(e) => {
                                  handleVarientNestedInput(
                                    "onChange",
                                    e,
                                    index,
                                  );
                                }}
                              />
                            </Stack>

                            <Button
                              variant="contained"
                              sx={{
                                minWidth: "36px",
                                maxWidth: "36px",
                                bgcolor: "rgba(0, 0, 0, 0.0)",
                                "&:hover": {
                                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                                },
                              }}
                              onClick={() => {
                                handleVarientNestedInput("delete", null, index);
                              }}
                              disabled={variants.length === 1 && index === 0}
                            >
                              <img alt="delete" src="/icons/ic_delete.svg" />
                            </Button>
                          </Stack>
                          <Divider sx={{ width: "100%" }} />
                        </>
                      ))}
                      <Button
                        variant="contained"
                        sx={{
                          mt: "20px",
                        }}
                        onClick={() => handleVarientNestedInput("add")}
                      >
                        Add Variant
                      </Button>
                    </>
                  ) : null}
                </Card>
              )}
            </>
          )}
        </ContentLayout>
      )}
    </>
  );
};
